export default {
    cash: "Наличными при получении",
    online: "Онлайн оплата",
    bank_card: "Банковская карта",
    alfabank: "Альфа-Клик",
    sbp: "СБП",
    tinkoff_bank: "Тинькофф",
    yoo_money: "ЮМани",
    qiwi: "QIWI Кошелек",
    sberbank: "SberPay",
    mobile_balance: "Баланс телефона"
}
